import EditorPreview from 'ui/components/forms/EditorPreview'
import { DescriptionWrapper, DescriptionTitle } from './styled'

const ExpandableCardBody = ({ template, compactPreview = false }) => (
  <DescriptionWrapper $compactPreview={compactPreview}>
    <DescriptionTitle>Описание</DescriptionTitle>
    <EditorPreview value={template} />
  </DescriptionWrapper>
)

export default ExpandableCardBody
